<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
                    <el-form-item label="托盘号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.pallentCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="操作人" class="EL-Form-Item">
                        <el-input v-model="mainSearch.person" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="单据编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.sgCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="reset">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
                    <el-form-item label="托盘编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.pallentCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="包装编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.boxBarcode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :lg="9" :xl="9">
                    <el-form-item label="日期范围" class="EL-Form-Item">
                        <el-date-picker style="width: 350px" v-model="mainSearch.date" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" @change="saveSearch()"></el-date-picker>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="组盘">
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M21_B1'" @click="showStockGroupDialog">新增</el-button>
                <el-button v-authority="'BACK_MENU3_M21_B2'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getStockGroupData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="selectAll">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="托盘号" prop="pallentCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="箱数" prop="countNumber" align="center">
                </el-table-column>
                <!-- <el-table-column label="计量单位" prop="mtUnit" align="center">
                </el-table-column> -->
                <el-table-column label="物料数量" prop="boxQuan" align="center">
                </el-table-column>
                <!-- <el-table-column label="单据编号" prop="sgCode" align="center">
                </el-table-column> -->
                <el-table-column label="组盘时间" prop="createTime" align="center">
                </el-table-column>
                <el-table-column label="操作人" prop="person" align="center">
                </el-table-column>
                <el-table-column label="操作" min-width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU3_M21_B3'" type="info" class="btn-t-select" @click="showStockGroupDetailDialog(scope.row.sgCode)">明细</el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!--组盘弹窗-->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="组盘" :visible.sync="stockGroupDialog">
            <div style="font-size: 16px">
                <el-form label-position="right" label-width="80px" class="EL-Form">
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="组盘箱号" class="EL-Form-Item">
                            <el-input el-input v-model="boxBarcode" placeholder="请输入" @keyup.enter.native="submit"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="6" :xl="6">
                        <el-form-item label="托盘号" class="EL-Form-Item">
                            <el-input el-input v-model="pallentCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button class="btn-t-edit" @click="submit" style="margin-left:0px">查询</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
                <h-table :headerCellStyle="stockGroupData.headerCellStyle" :style="$popups.harvestRecordStyle(0.685)" :data="stockGroupData.data">
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="物料数量" prop="matQuan" align="center">
                    </el-table-column>
                    <el-table-column label="批次号" prop="batchNo" align="center">
                    </el-table-column>
                    <el-table-column label="库位编号" prop="lcCode" align="center">
                    </el-table-column>
                    <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column>
                    <el-table-column label="状态" prop="wiStatus" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                            <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                            <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                            <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                            <span v-if="scope.row.wiStatus == 'AGFREEZE'">人工冻结</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="入库时间" prop="matCreateTime" align="center" width="140px">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="
                  deleteRow(scope.$index, stockGroupData.data)
                " class="btn-t-delete">移除</el-button>
                        </template>
                    </el-table-column>
                </h-table>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeStockGroupDialog()" class="btn-t-info">取 消</el-button>
                <el-button :loading="insertStockGroups" class="btn-t-edit" @click="insertStockGroup()">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 组盘记录详情 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="组盘详情" :visible.sync="stockGroupDetailDialog">
            <h-table :headerCellStyle="stockGroupDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.75)" :data="stockGroupDetailData.data">
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column label="托盘号" prop="pallentCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="物料数量" prop="boxQuan" align="center">
                </el-table-column>
                <el-table-column label="批次号" prop="batchNo" align="center">
                </el-table-column>
                <el-table-column label="通道" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="货位号" prop="lcCode" align="center">
                </el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="组盘时间" prop="createTime" align="center" width="160px">
                </el-table-column>
                <!-- <el-table-column label="更改时间" prop="updateTime" align="center" width="160px">
                </el-table-column> -->
                <el-table-column label="操作人" prop="person" align="center">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeStockGroupDetailDialog" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "ConstituteDisc",
        data() {
            return {
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                // 筛选条件
                mainSearch: {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    pallentCode: "", //托盘编号
                    person: "",
                    matCode: "",
                    matName: "",
                    date: [],
                },
                //全选
                checkList: [],
                //组盘窗口
                stockGroupDialog: false,
                //组盘详情窗口
                stockGroupDetailDialog: false,
                //组盘编号
                sgCode: "",
                //组盘对象集合
                stockGroupData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //阻盘明细对象集合
                stockGroupDetailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //操作人
                person: localStorage.getItem("user"),
                //操作人工号
                personNumber: localStorage.getItem("empNumber"),
                //箱号
                boxBarcode: "",
                //托盘号
                pallentCode: "",
                //箱号是否存在flag
                boxBarcodeFlag: true,

                downloadLoading: false, //下载中
                insertStockGroups: false,

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000);
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
        },
        methods: {
            /**
             * 多选
             */
            selectAll(selection) {
                this.checkList = selection;
            },
            //打开组盘窗口
            showStockGroupDialog() {
                this.stockGroupDialog = true;
            },
            //关闭组盘窗口
            closeStockGroupDialog() {
                this.stockGroupDialog = false;
                this.boxBarcode = "";
                this.stockGroupData.data = [];
                this.pallentCode = "";
            },
            //打开组盘明细窗口
            showStockGroupDetailDialog(sgCode) {
                this.stockGroupDetailDialog = true;
                this.sgCode = sgCode;
                this.getStockGroupDetail();
            },
            //关闭组盘明细窗口
            closeStockGroupDetailDialog() {
                this.stockGroupDetailDialog = false;
            },
            //删除组盘的箱
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.clickSelectList()
                }, 1000)
            },
            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.mainData.nowPage = 1;
                this.getStockGroupData(newVal);
            },
            /**
             * 获取组盘记录
             */
            getStockGroupData() {
                this.$http
                    .request({
                        url: "/api/stockMove/getStockGroupPage",
                        method: "GET",
                        params: {
                            // person: localStorage.getItem("user") || "",
                            pageNum: this.mainData.nowPage, //	页号
                            pageSize: this.mainData.pageSize, //	页大小
                            fcCode: this.mainSearch.fcCode || null, //	工厂编号
                            //sgCode: this.mainSearch.sgCode || null, //	单据编号
                            matCode: this.mainSearch.matCode || null, //	物料编号
                            matName: this.mainSearch.matName || null, //	物料描述
                            pallentCode: this.mainSearch.pallentCode || null, //	托盘号
                            person: this.mainSearch.person || null, //	操作人
                            //boxBarcode: this.mainSearch.boxBarcode || null, //	包装编号
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainData.data = res.data.list;
                            this.mainData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 根据组盘编号查询详情
             */
            getStockGroupDetail() {
                //根据组盘编号获取详细信息
                this.$http
                    .request({
                        url: "/api/stockMove/getStockGroupList",
                        method: "GET",
                        params: {
                            sgCode: this.sgCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.stockGroupDetailData.data = resp.data;
                            this.stockGroupDetailData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 回车提交
             */
            submit() {
                //根据箱号查询库存
                //判断是否输入了正确的箱号
                if (this.boxBarcode == "") {
                    this.$message({
                        message: "请输入箱号！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$http
                        .request({
                            url: "/api/SplitMergeMatChange/getStockByBoxBarcode",
                            method: "GET",
                            showLoading: true,
                            params: {
                                boxBarcode: this.boxBarcode, //箱号
                            },
                            data: this.unpack,
                        })
                        .then((res) => {
                            if (res.status == 100) {
                                var barCode = res.data.list[0].boxBarcode; //箱号
                                var matCodeOne = res.data.list[0].matCode; //物料编号
                                //判断此箱号是否是该工厂的
                                if (localStorage.getItem("fcCode") != res.data.list[0].fcCode) {
                                    this.boxBarcodeFlag = false;
                                    this.$message({
                                        message: "该工厂没有此箱号！",
                                        type: "warning",
                                    });
                                    return;
                                }
                                //判断箱号是否一样
                                this.stockGroupData.data.forEach((item) => {
                                    if (barCode == item.boxBarcode) {
                                        this.boxBarcodeFlag = false;
                                        this.$message({
                                            message: "请不要输入相同的箱号！",
                                            type: "warning",
                                        });
                                        return;
                                    } 
                                    // else if (matCodeOne != item.matCode) {
                                    //     this.boxBarcodeFlag = false;
                                    //     this.$message({
                                    //         message: "请输入物料相同的箱号！",
                                    //         type: "warning",
                                    //     });
                                    //     return;
                                    // }
                                });
                                //箱号不相同及物料相同的情况下
                                if (this.boxBarcodeFlag) {
                                    this.stockGroupData.data.push(res.data.list[0]);
                                    this.boxBarcode = "";
                                    this.stockGroupData.total += 1;
                                }
                                this.boxBarcodeFlag = true;
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: "error",
                                });
                            }
                        });
                }
            },
            /**
             * 进行组盘
             */
            insertStockGroup() {
                if (this.stockGroupData.data.length == 0) {
                    this.$message({
                        message: "请输入需组盘的箱号！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.insertStockGroups = true;
                    //进行组盘
                    this.$confirm("确认开始组盘吗?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.stockGroupData.data.forEach((item) => {
                                // item.pallentCode = this.pallentCode;
                                item.person = this.person;
                                item.personNumber = this.personNumber;
                                item.fcCode = localStorage.getItem("fcCode") || "";
                                item.boxQuan = item.matQuan;
                                item.createTime = "";
                                item.updateTime = "";
                            });
                            this.$http
                                .request({
                                    url: "/api/stockMove/insertStockGroup",
                                    method: "POST",
                                    showLoading: true,
                                    data: this.stockGroupData.data,
                                })
                                .then((res) => {
                                    this.logContent = JSON.stringify(this.stockGroupData.data);
                                    if (res.status == 100) {
                                        this.mainData.data = res.data;
                                        this.mainData.total = res.total;
                                        this.stockGroupDialog = false;
                                        this.boxBarcode = "";
                                        this.stockGroupData.data = [];
                                        this.pallentCode = "";
                                        this.$message({
                                            message: "组盘成功!",
                                            type: "success",
                                        });
                                        this.logRemarks = "stockGroup：组盘成功";
                                        this.getStockGroupData();
                                    } else {
                                        this.$message.error("错误");
                                        this.logRemarks = "stockGroup：组盘失败";
                                    }
                                    this.insertStockGroups = false;
                                    this.systemLog();
                                });
                        })
                        .catch(() => {
                            this.insertStockGroups = false;
                            this.$message({
                                type: "info",
                                message: "已取消组盘",
                            });
                        });
                }
            },
            /**
             * 重置
             */
            reset() {
                this.mainSearch = {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    pallentCode: "", //托盘编号
                    date: [],
                };
                this.getStockGroupData()
            },

            //表格导出
            downLoadFile() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请选中需要导出的组盘记录！",
                        type: "warning",
                    });
                    return;
                }
                this.downloadLoading = true;
                var sgCodeList = "";
                this.checkList.forEach((item)=>{
                    if(sgCodeList == ""){
                        sgCodeList += item.sgCode;
                    }else{
                        sgCodeList += "," + item.sgCode;   
                    }
                })
                var paramsObj = {
                    // person: localStorage.getItem("user") || "",
                    // fcCode: this.mainSearch.fcCode || null, // 工厂编号
                    // sgCode: this.mainSearch.sgCode || null, // 单据编号
                    // matCode: this.mainSearch.matCode || null, // 物料编号
                    // matName: this.mainSearch.matName || null, // 物料描述
                    sgCode: sgCodeList || null, // 托盘号
                    //boxBarcode: this.mainSearch.boxBarcode || null, // 包装编号
                    // person: this.mainSearch.person || null, // 包装编号
                    // pallentCodeList: pallentCodeList || null, // 托盘号
                    // beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                    // endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/stockMove/getStockGroupList',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['托盘号', '物料编号', '物料描述', '箱数', '物料数量', '组盘时间', '操作人']
                    const filterVal = ['pallentCode', 'matCode','matName', 'countNumber', 'boxQuan', 'createTime', 'person']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '组盘单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出组盘记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "组盘",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || null,
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getStockGroupData();
        },
    };
</script>

<style scoped>
</style>